
export function totalqysl_simple() {
	var taglist = [
		{ tagCode: "A090108", tagName: "世界500强（内资）", },
		{ tagCode: "A090117", tagName: "世界500强（外资）", },
		{ tagCode: "A090109", tagName: "中国500强", },
		{ tagCode: "A090110", tagName: "中国民营企业500强", },
		{ tagCode: "A090111", tagName: "中国制造业民营企业500强", },
		{ tagCode: "A090120", tagName: "链主企业", },
		{ tagCode: "A020131", tagName: "央企", },
		{ tagCode: "A020104", tagName: "国有企业", },
		{ tagCode: "A090112", tagName: "中国服务业民营企业100强", },
		{ tagCode: "A090116", tagName: "战略性新兴产业领军企业100强", },
		{ tagCode: "A090101", tagName: "独角兽企业", },
		{ tagCode: "A090102", tagName: "隐形冠军企业", },
		{ tagCode: "A090103", tagName: "专精特新小巨人企业", },
		{ tagCode: "A090104", tagName: "瞪羚企业", },
		{ tagCode: "A090105", tagName: "科技小巨人企业", },
		{ tagCode: "A090106", tagName: "制造业单项冠军", },
		{ tagCode: "A080101", tagName: "专精特新中小企业", },
		{ tagCode: "A090201", tagName: "上市公司", },
		{ tagCode: "A090118", tagName: "拟上市辅导备案企业", },
		{ tagCode: "A080116", tagName: "新三板挂牌公司", },
	];
	return taglist;
}
export function totalqysl() {//全部内资的企业实力
	var taglist = [
		{ tagCode: "A090108", type: 'ss', fwb: true, tagName: "世界500强(内资)", },
		{ tagCode: "A090117", type: 'ss', fwb: true, tagName: "世界500强(外资)", },
		{ tagCode: "A090109", type: 'ss', fwb: true, tagName: "中国500强", },
		{ tagCode: "A090110", type: 'ss', fwb: true, tagName: "中国民营企业500强", },
		{ tagCode: "A090111", type: 'ss', fwb: true, tagName: "中国制造业民营企业500强", },
		{ tagCode: "A090120", type: 'ss', fwb: true, tagName: "链主企业", },
		{ tagCode: "A020131", type: 'ss', fwb: true, tagName: "央企", },
		{ tagCode: "A090101", type: 'ss', fwb: true, tagName: "独角兽企业", },
		{ tagCode: "A090102", type: 'ss', fwb: true, tagName: "隐形冠军企业", },
		{ tagCode: "A090105", type: 'ss', fwb: true, tagName: "科技小巨人企业", },
		{ tagCode: "A090106", type: 'ss', fwb: true, tagName: "制造业单项冠军", },
		{ tagCode: "A090103", type: 'ss', fwb: true, tagName: "专精特新小巨人企业", },
		{ tagCode: "A080101", type: 'yz', fwb: true, tagName: "专精特新中小企业", },
		{ tagCode: "A020104", type: 'ss', tagName: "国有企业", },
		{ tagCode: "A090112", type: 'ss', tagName: "中国服务业民营企业100强", },
		{ tagCode: "A090116", type: 'ss', tagName: "战略性新兴产业领军企业100强", },
		{ tagCode: "A090104", type: 'ss', tagName: "瞪羚企业", },
		{ tagCode: "A090107", type: 'ss', tagName: "2021全球独角兽", },
		{ tagCode: "A090113", type: 'ss', tagName: "重点企业", },
		{ tagCode: "A090114", type: 'ss', tagName: "标杆企业", },
		{ tagCode: "A090115", type: 'ss', tagName: "知名企业", },
		{ tagCode: "A080115", type: 'yz', tagName: "猎豹企业", },
		{ tagCode: "A080103", type: 'yz', tagName: "牛羚企业", },
		{ tagCode: "A080102", type: 'yz', tagName: "雏鹰企业", },
		{ tagCode: "A080105", type: 'yz', tagName: "科技型中小企业", },
		{ tagCode: "A080106", type: 'yz', tagName: "民营科技企业", },
		{ tagCode: "A080107", type: 'yz', tagName: "企业技术中心", },
		{ tagCode: "A080108", type: 'yz', tagName: "众创空间", },
		{ tagCode: "A080109", type: 'yz', tagName: "科技企业孵化器", },
		{ tagCode: "A080110", type: 'yz', tagName: "技术创新示范企业", },
		{ tagCode: "A080111", type: 'yz', tagName: "技术先进型服务企业", },
		{ tagCode: "A090119", type: 'yz', tagName: "终止辅导企业", },
		{ tagCode: "A090201", type: 'yz', tagName: "上市公司", },
		{ tagCode: "A090118", type: 'yz', tagName: "拟上市辅导备案企业", },
		{ tagCode: "A080116", type: 'yz', tagName: "新三板挂牌公司", },
		{ tagCode: "A080117", type: 'yz', tagName: "名企背景", },
		{ tagCode: "A080118", type: 'yz', tagName: "创新型中小企业", },
		{ tagCode: "A080114", type: 'yz', tagName: "高新技术企业", },

	];
	return taglist;
}
export function totalqysl_yz() {
	var taglist = [
		{ tagCode: "A080101", type: 'yz', tagName: "专精特新中小企业", fwb: true, },
		{ tagCode: "A080116", type: 'yz', tagName: "新三板挂牌公司", fwb: true, },
		{ tagCode: "A080102", type: 'yz', tagName: "雏鹰企业", },
		{ tagCode: "A080103", type: 'yz', tagName: "牛羚企业", },
		{ tagCode: "A080105", type: 'yz', tagName: "科技型中小企业", },
		{ tagCode: "A080106", type: 'yz', tagName: "民营科技企业", },
		{ tagCode: "A080107", type: 'yz', tagName: "企业技术中心", },
		{ tagCode: "A080108", type: 'yz', tagName: "众创空间", },
		{ tagCode: "A080109", type: 'yz', tagName: "科技企业孵化器", },
		{ tagCode: "A080110", type: 'yz', tagName: "技术创新示范企业", },
		{ tagCode: "A080111", type: 'yz', tagName: "技术先进型服务企业", },
		{ tagCode: "A080114", type: 'yz', tagName: "高新技术企业", },
		{ tagCode: "A080115", type: 'yz', tagName: "猎豹企业", },
		{ tagCode: "A090119", type: 'yz', tagName: "终止辅导企业", },
		{ tagCode: "A090201", type: 'yz', tagName: "上市公司", },
		{ tagCode: "A090118", type: 'yz', tagName: "拟上市辅导备案企业", },
		{ tagCode: "A080117", type: 'yz', tagName: "名企背景", },
		{ tagCode: "A080118", type: 'yz', tagName: "创新型中小企业", },
	];
	return taglist;
}
export function totalqysl_ss() {
	var taglist = [
		{ tagCode: "A090108", type: 'ss', tagName: "世界500强(内资)", fwb: true, },
		{ tagCode: "A090117", type: 'ss', tagName: "世界500强(外资)", fwb: true, },
		{ tagCode: "A090109", type: 'ss', tagName: "中国500强", fwb: true, },
		{ tagCode: "A090110", type: 'ss', tagName: "中国民营企业500强", fwb: true, },
		{ tagCode: "A090111", type: 'ss', tagName: "中国制造业民营企业500强", fwb: true, },
		{ tagCode: "A020131", type: 'ss', tagName: "央企", fwb: true, },
		{ tagCode: "A020104", type: 'ss', tagName: "国有企业", fwb: true, },
		{ tagCode: "A090112", type: 'ss', tagName: "中国服务业民营企业100强", },
		{ tagCode: "A090116", type: 'ss', tagName: "战略性新兴产业领军企业100强", },
		{ tagCode: "A090101", type: 'ss', tagName: "独角兽企业", },
		{ tagCode: "A090102", type: 'ss', tagName: "隐形冠军企业", },
		{ tagCode: "A090103", type: 'ss', tagName: "专精特新小巨人企业", },
		{ tagCode: "A090104", type: 'ss', tagName: "瞪羚企业", },
		{ tagCode: "A090105", type: 'ss', tagName: "科技小巨人企业", },
		{ tagCode: "A090106", type: 'ss', tagName: "制造业单项冠军", },
		{ tagCode: "A090107", type: 'ss', tagName: "2021全球独角兽", },
		{ tagCode: "A090113", type: 'ss', tagName: "重点企业", },
		{ tagCode: "A090114", type: 'ss', tagName: "标杆企业", },
		{ tagCode: "A090115", type: 'ss', tagName: "知名企业", },
		{ tagCode: "A090120", type: 'ss', tagName: "链主企业", },
	];
	return taglist;
}
export function totalqysl_lt() {
	const taglist = [
	{tagName: "世界500强(内资)",tagCode: "A090108", fwb: true,},
	{tagName: "世界500强(外资)",tagCode: "A090117", fwb: true,}, 
	{tagName: "中国500强",tagCode: "A090109", fwb: true,}, 
	{tagName: "中国民营企业500强",tagCode: "A090110", fwb: true,}, 
	{tagName: "中国制造业民营企业500强",tagCode: "A090111", fwb: true,},
	{tagName: '拟上市辅导备案企业',tagCode: 'A090118', fwb: true,}, 
	{tagName: "央企",tagCode: "A020131", fwb: true,},
	{tagName: "国有企业",tagCode: "A020104", fwb: true,},
	{tagName: "中国服务业民营企业100强",tagCode: "A090112"}, 
	{tagName: "战略性新兴产业领军企业100强",tagCode: "A090116"},
	{tagCode: "A090101", type: 'lt', tagName: "独角兽企业", },
	{ tagCode: "A090102", type: 'lt', tagName: "隐形冠军企业", },
	{ tagCode: "A090103", type: 'lt', tagName: "专精特新小巨人企业", },
	{ tagCode: "A090104", type: 'lt', tagName: "瞪羚企业", },
	{ tagCode: "A090105", type: 'lt', tagName: "科技小巨人企业", },
	{ tagCode: "A090106", type: 'lt', tagName: "制造业单项冠军", },
	{ tagCode: "A090107", type: 'lt', tagName: "2021全球独角兽", },
	{ tagCode: "A090113", type: 'lt', tagName: "重点企业", },
	{ tagCode: "A090114", type: 'lt', tagName: "标杆企业", },
	{ tagCode: "A090115", type: 'lt', tagName: "知名企业", },
	{ tagCode: "A090120", type: 'lt', tagName: "链主企业", },
	{ tagCode: "A090119", type: 'lt', tagName: "终止上市辅导企业", },
	];
	return taglist;
}
export function financing_rounds() {
	var taglist = [
		{ tagName: "全部", tagCode: '' },
		{ tagName: "种子轮", tagCode: 10 },
		{ tagName: "天使轮", tagCode: 20 },
		{ tagName: "Pre-A轮", tagCode: 30 },
		{ tagName: "A轮", tagCode: 40 },
		{ tagName: "A+轮", tagCode: 50 },
		{ tagName: "Pre-B轮", tagCode: 60 },
		{ tagName: "B轮", tagCode: 70 },
		{ tagName: "B+轮", tagCode: 80 },
		{ tagName: "C轮", tagCode: 90 },
		{ tagName: "C+轮", tagCode: 100 },
		{ tagName: "D轮", tagCode: 110 },
		{ tagName: "D+轮", tagCode: 120 },
		{ tagName: "E轮", tagCode: 130 },
		{ tagName: "E+轮", tagCode: 140 },
		{ tagName: "F轮", tagCode: 150 },
		{ tagName: "G轮", tagCode: 160 },
		{ tagName: "H轮", tagCode: 170 }
	];
	return taglist;
}
export function order_list(data) {
	var dimensionList = [{
		name: '综合',
		type: 0,
	}, {
		name: '融资时间',
		type: 1,
	}, {
		name: '企业实力',
		type: 2,
	}, {
		name: '投资力度',
		type: 3,
	},
	{
		name: '本省关联度',
		type: 4,
	}, {
		name: '拿地数量',
		type: 5,
	}, {
		name: '拿地面积',
		type: 6,
	}, {
		name: '拿地金额',
		type: 7,
	},
	{
		name: '投资项目数量',
		type: 8,
	}, {
		name: '投资项目金额',
		type: 9,
	}, {
		name: '控制企业',
		type: 10,
	},
	];

	var list2 = dimensionList.filter(item => {
		return data.indexOf(item.type) > -1;
	})

	return list2;
}